import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Operations } from '../../_models/general.model';
const getPages = createFeatureSelector<any>('pages');

export const getAllPagesLoading = createSelector(
  getPages,
  (state: any) => state.pagesLoading
);

/**
 * Get all pages
 */

export const getAllPages = createSelector(
  getPages,
  (state: any) => state.pages
);

/**
 * Get Page Detals
 */
export const getPageDetail = createSelector(
  getPages,
  (state: any) => state.pageDetails
);

/**
 * Select operations
 */
export const getPagesOperations = createSelector(
  getPages,
  (state: Operations) => state.operations
);

/**
 * Get Default page for table
 */
export const getDefaultPageForTable = createSelector(
  getPages,
  (state: Operations) => state.defaultPage
);
